export const REQUEST_CHARTS = 'zola/seatingChart/request_charts';
export const RECEIVE_CHARTS = 'zola/seatingChart/receive_charts';
export const REQUEST_CHART = 'zola/seatingChart/request_chart';
export const RECEIVE_CHART = 'zola/seatingChart/receive_chart';
export const CREATE_CHART = 'zola/seatingChart/create_chart';
export const UPDATE_CHART = 'zola/seatingChart/update_chart';
export const DELETE_CHART = 'zola/seatingChart/delete_chart';
export const REDIRECT_CHART = 'zola/seatingChart/redirect_chart';
export const CHANGE_VIEW = 'zola/seatingChart/change_view';
export const SHOW_DETAILS = 'zola/seatingChart/show_details';
export const REQUEST_TABLE = 'zola/seatingChart/request_table';
export const RECEIVE_TABLE = 'zola/seatingChart/receive_table';
export const REQUEST_TABLES = 'zola/seatingChart/request_tables';
export const RECEIVE_TABLES = 'zola/seatingChart/receive_tables';
export const CREATE_TABLE = 'zola/seatingChart/create_table';
export const DELETE_TABLE = 'zola/seatingChart/delete_table';
export const UPDATE_TABLE = 'zola/seatingChart/update_table';
export const REORDER_TABLES = 'zola/seatingChart/reorder_table';
export const SELECT_GUESTS = 'zola/seatingChart/select_guests';
export const EXPAND_GUEST_GROUP = 'zola/seatingChart/expand_guest_group';
export const CREATE_UPDATE_SEAT = 'zola/seatingChart/create_update_seat';
export const REORDER_SEATS = 'zola/seatingChart/reorder_seat';
export const LOAD_EDIT_TABLE = 'zola/seatingChart/load_edit_table';
export const CHANGE_SELECTED_CHART = 'zola/seatingChart/change_selected_chart';



/** WEBPACK FOOTER **
 ** ./src/actions/types/SeatingChartActionTypes.js
 **/